import { Modal, Button, Form } from "react-bootstrap";

interface SaveReportModalProps {
  show: boolean;
  onClose: () => void;
  onSave: () => void;
  reportName: string;
  setReportName: (name: string) => void;
}

export function SaveReportModal({
  show,
  onClose,
  onSave,
  reportName,
  setReportName,
}: SaveReportModalProps) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Save Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="reportName">
          <Form.Label>Report Name</Form.Label>
          <Form.Control
            type="text"
            value={reportName}
            onChange={(e) => setReportName(e.target.value)}
            placeholder="Enter a unique name"
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
            setReportName("");
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onSave}
          disabled={!reportName.trim()}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
